import { useState } from 'react'
import { useLazyQuery } from 'components/graphql'
import { listClosings } from '../gql'

const useClosingSum = ({ variables }) => {
	const params = { ...variables.params, limit: 0, cursors: null }
	const filter = { ...variables.filter, inactive: false }

	const [isSum, setIsSum] = useState(false)
	const [ loadSum, { data, loading } ] = useLazyQuery(listClosings, {
		variables: { ...variables, filter, params }
	})

	const sum = (a, b) => (a * 10000 + b * 10000) / 10000

	const getAllSalesGroup = (initArray) => {
		if(!initArray) {
			return []
		}
		const salesGroupsArr = initArray.reduce((resArr, closing) => {
			if (Array.isArray(closing.salesGroups)) {
				return resArr.concat(closing.salesGroups)
			}
			return resArr
		}, [])
		const salesGroupsMap = salesGroupsArr.reduce((total, sg) => {
			const sgId = sg.salesGroup.id
			if(typeof total[sgId] === 'undefined') {
				total[sgId] = { ...sg }
				return total
			}
			total[sgId].amount = sum(total[sgId].amount, sg.amount)
			total[sgId].discount = sum(total[sgId].discount, sg.discount)
			total[sgId].mWStFree = sum(total[sgId].mWStFree, sg.mWStFree)
			total[sgId].mWStNormal = sum(total[sgId].mWStNormal, sg.mWStNormal)
			total[sgId].mWStReduced = sum(total[sgId].mWStReduced, sg.mWStReduced)
			total[sgId].mWStSpecial = sum(total[sgId].mWStSpecial, sg.mWStSpecial)
			total[sgId].reduction = sum(total[sgId].reduction, sg.reduction)
			total[sgId].total = sum(total[sgId].total, sg.total)
			return total
		}, {})
		return Object.values(salesGroupsMap)
	}

	const getAllUsersData = (initArray) => {
		if(!initArray) {
			return []
		}
		const usersArr = initArray.reduce((resArr, closing) => {
			if (Array.isArray(closing.users)) {
				return resArr.concat(closing.users)
			}
			return resArr
		}, [])

		let totalBillCount = 0
		let totalAmount = 0
		const usersMap = usersArr.reduce((map, userRecord) => {
			const userId = userRecord.user.id
			if(typeof map[userId] === 'undefined') {
				map[userId] = { ...userRecord }
				return map
			}
			totalBillCount = totalBillCount + userRecord.clientCount
			totalAmount = sum(totalAmount, userRecord.total)

			map[userId].total = sum(map[userId].total, userRecord.total)
			map[userId].clientCount = sum(map[userId].clientCount, userRecord.clientCount)
			map[userId].cancellationsCount = sum(map[userId].cancellationsCount, userRecord.cancellationsCount)
			map[userId].cancellationsAmount = sum(map[userId].cancellationsAmount, userRecord.cancellationsAmount)
			map[userId].buttonOpenCount = sum(map[userId].buttonOpenCount, userRecord.buttonOpenCount)
			map[userId].buttonBackCount = sum(map[userId].buttonBackCount, userRecord.buttonBackCount)
			map[userId].buttonDelCount = sum(map[userId].buttonDelCount, userRecord.buttonDelCount)
			map[userId].buttonDelAmount = sum(map[userId].buttonDelAmount, userRecord.buttonDelAmount)
			map[userId].inCafeCount = sum(map[userId].inCafeCount, userRecord.inCafeCount)
			map[userId].inCafeAmount = sum(map[userId].inCafeAmount, userRecord.inCafeAmount)
			map[userId].tipsTotal = sum(map[userId].tipsTotal, userRecord.tipsTotal)

			return map
		}, {})
		const totalAverageBill = totalBillCount ? totalAmount / totalBillCount : null
		return Object.values(usersMap).map(user => {
			const averageBill = user.clientCount ? user.total / user.clientCount : null
			return {
				...user,
				averageBill,
				userEfficiency: averageBill ? (averageBill / totalAverageBill * 100).toFixed(1) : null,
				inCafePercent: user.total ? (user.inCafeAmount * 100 / user.total).toFixed(1) : null
			}
		})
	}

	return {
		toggleSum: () => {
			if(!isSum) {
				setIsSum(true)
				loadSum()
			} else {
				setIsSum(false)
			}
		},
		isSum,
		loading,
		data: {
			salesGroups: getAllSalesGroup(data.listClosings?.items),
			users: getAllUsersData(data.listClosings?.items)
		}
	}
}

export default useClosingSum